import * as Yup from "yup";
import {
  createRequiredMonthYearShape,
  futureDateMessage,
  invalidValue,
  monthYearNotAfterCurrentDate, 
  numberBetweenHundredAndTenThousand, 
  requiredDigitOrLetterInputFieldRegex,
  employmentTypeRequiredMessage,
  businessNameRequiredMessage,
  incomeFrequencyRequiredMessage,
  totalIncomeRequiredMessage,
} from "./shared";

export const livelihoodSchema = Yup.object({
  employmentBasis: Yup.string().trim().required(employmentTypeRequiredMessage),

  dateStarted: Yup.object()
    .shape(createRequiredMonthYearShape())
    .test("test-notaftertoday", futureDateMessage, monthYearNotAfterCurrentDate),

  businessName: Yup.string()
    .trim()
    .required(businessNameRequiredMessage)
    .matches(requiredDigitOrLetterInputFieldRegex, {
      message: invalidValue,
      excludeEmptyString: true,
    }),
  
  incomeFrequency: Yup.string().trim().required(incomeFrequencyRequiredMessage),

  totalIncome: Yup.string()
    .trim()
    .test("test-MinMax", numberBetweenHundredAndTenThousand, (value) => {
      const isValid = value >= 100 && value <= 10000;
      return isValid;
    })
    .required(totalIncomeRequiredMessage),  
});